<template>
    <navigation-menu />
</template>

<script>
    import PublicDashboard from './PublicDashboard';
    import CxDashboard     from './CxDashboard';
    import NpsDashboard    from './NpsDashboard';
    import Leaderboards    from './../leaderboards/Leaderboards';

    import VueRouter from 'vue-router';

    const router = new VueRouter({
        routes: [
            { path: '/public', component: PublicDashboard, label: 'Public Reviews' },
            { path: '/cx', component: CxDashboard, label: 'Customer Experience (CX)' },
            { path: '/nps', component: NpsDashboard, label: 'Net Promoter Score (NPS)' },
            { path: '/leaderboards', component: Leaderboards, label: 'Leaderboards' },
            { path: '/', redirect: '/public' },
        ],
        linkActiveClass: 'active',
        linkExactActiveClass: 'exact-active',
    });

    export default {
        router,
    }
</script>
